import React from "react";
import { NextSeo } from "next-seo";
import NewsletterHero from "src/components/Newsletter/NewsletterHero";
import EmailStateCapture from "src/components/EmailStateCapture";
import NewsletterArticles from "src/components/Newsletter/NewsletterActicles";
import NewsletterFeatures from "src/components/Newsletter/NewsletterFeatures";
import styles from "src/styles/newsletter.scss";

const Newsletter = () => {
  return (
    <div className="newsletter">
      <NextSeo
        title="Newsletter | BetQL"
        openGraph={{
          url: "https://www.betql.co/newsletter",
        }}
      />
      <NewsletterHero />
      <EmailStateCapture />
      <NewsletterFeatures />
      <NewsletterArticles />
      <style jsx>{styles}</style>
    </div>
  );
};

export default Newsletter;
